import React, { useState, useEffect } from 'react';
import { BiData, SearchClickBiEvent } from '@wix/da-bi/pkg/events';
import QuickSearch from './QuickSearch';

export interface Props {
  currSearch?: string;
  className?: string;
}

const QUICK_SEARCHES: { text: string; term: string }[] = [
  // note: keep the names plain with no spaces as they're used in the click_info of the BI
  { text: 'Halloween', term: 'Halloween' },
  { text: 'Adoptables', term: 'Adoptables' },
  { text: 'Avatar', term: 'Avatar' },
  { text: 'Portrait', term: 'Portrait' },
  { text: 'Wallpaper', term: 'Wallpaper' },
];

/** a horizontal list of shop searches that maintains the current window location path */
const QuickSearchList: React.FC<Props> = ({ currSearch = '', className }) => {
  const [pathname, setPathname] = useState('/shop');

  // use the current window.location.pathname to allow the search tag href's
  // to remain in the same searchPageType (instead of sending them to 'all')
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const windowPathname = window.location.pathname;
      const newPathname = windowPathname.endsWith('/search')
        ? windowPathname
        : `${windowPathname}/search`;
      setPathname(newPathname);
    }
  }, []);

  return (
    <div className={className}>
      {QUICK_SEARCHES.map(quicksearch => {
        return (
          <QuickSearch
            key={quicksearch.text}
            href={`${pathname}?q=${encodeURIComponent(quicksearch.term)}`}
            biData={BiData<SearchClickBiEvent>({
              evid: 710,
              search_terms: quicksearch.term,
              sectionname: 'shop_tag',
            })}
          >
            {quicksearch.text}
          </QuickSearch>
        );
      })}
    </div>
  );
};

QuickSearchList.displayName = 'QuickSearchList';
export default QuickSearchList;
